export default {
  id: "totalInventoryCount",
  name: "",
  description: "",
  report: {
    name: "Total inventory count",
    template: "custom",
    chartType: "NUMBER",
    config: {
      dataType: "single",
      dataSet: "InventoryItem",
      dimensions: [],
      measures: ["InventoryItem.total_inventory"],
      sort: {
        direction: "",
        by: "",
      },
      filters: [],
      compare: false,
      limit: "10",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
    },
  },
};
